import React from "react";

const AppAppleSvg = () => {
    return (
        <svg
            width="35"
            height="40"
            viewBox="0 0 35 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.4867 31.1723C32.8817 32.5698 32.1657 33.8562 31.3361 35.0388C30.2053 36.6511 29.2794 37.7672 28.5658 38.3869C27.4597 39.4041 26.2745 39.9251 25.0054 39.9547C24.0943 39.9547 22.9956 39.6955 21.7166 39.1696C20.4335 38.6461 19.2542 38.3869 18.176 38.3869C17.0452 38.3869 15.8324 38.6461 14.5351 39.1696C13.2359 39.6955 12.1893 39.9696 11.3891 39.9967C10.1721 40.0486 8.959 39.5128 7.74818 38.3869C6.97536 37.7128 6.00872 36.5573 4.85073 34.9203C3.6083 33.1722 2.58685 31.1451 1.78663 28.8341C0.929617 26.3379 0.5 23.9207 0.5 21.5805C0.5 18.8998 1.07924 16.5878 2.23945 14.6503C3.15128 13.0941 4.36433 11.8665 5.88255 10.9653C7.40078 10.064 9.04122 9.6048 10.8078 9.57542C11.7745 9.57542 13.0421 9.87442 14.6174 10.4621C16.1882 11.0517 17.1968 11.3507 17.639 11.3507C17.9696 11.3507 19.0901 11.0011 20.9895 10.304C22.7857 9.65764 24.3018 9.38999 25.5437 9.49542C28.909 9.76702 31.4373 11.0936 33.1188 13.4837C30.109 15.3073 28.6201 17.8616 28.6498 21.1383C28.6769 23.6905 29.6028 25.8144 31.4225 27.5008C32.2472 28.2835 33.1681 28.8884 34.1928 29.318C33.9706 29.9625 33.736 30.5797 33.4867 31.1723ZM25.7679 0.800223C25.7679 2.80068 25.0371 4.6685 23.5804 6.39734C21.8224 8.45258 19.696 9.6402 17.3902 9.4528C17.3608 9.21281 17.3438 8.96022 17.3438 8.6948C17.3438 6.77436 18.1798 4.71912 19.6644 3.03867C20.4056 2.18784 21.3483 1.48037 22.4915 0.916022C23.6322 0.360088 24.7112 0.0526404 25.726 0C25.7556 0.267424 25.7679 0.534873 25.7679 0.800198V0.800223Z"
                fill="black"
                fillOpacity="0.55"
            />
        </svg>
    );
};

export default AppAppleSvg;
